import { PopconfirmButton } from '@/components/_SiteWide/PopconfirmButton'
import { SaveOutlined, CloseCircleOutlined, EditOutlined } from '@ant-design/icons'
import { Horizontal, Vertical, Texto, GraviButton } from '@gravitate-js/excalibrr'
import { Form, Tooltip } from 'antd'
import TextArea from 'antd/es/input/TextArea'
import { FormInstance } from 'antd/lib'

type PeriodDetailsEditButtonsProps = {
  editing: boolean
  setEditing: (editing: boolean) => void
  overrideReason: string | undefined | null
  form: FormInstance
  payrollType: 'shift' | 'order'
}

export function PeriodDetailsEditButtons({
  editing,
  setEditing,
  overrideReason,
  form,
  payrollType,
}: PeriodDetailsEditButtonsProps) {
  return (
    <Horizontal gap={2} verticalCenter>
      {editing ? (
        <>
          <PopconfirmButton
            onConfirm={() => {
              setEditing(false)
              form.submit()
            }}
            buttonProps={{ icon: <SaveOutlined />, size: 'small' }}
            popconfirmProps={{
              title: `Save ${payrollType} pay overrides?`,
              description: (
                <Vertical>
                  <Texto category='label' weight={'bold'}>
                    Reason for overriding {payrollType} pay:
                  </Texto>
                  <Form.Item name='override_reason' noStyle>
                    <TextArea
                      defaultValue={overrideReason || undefined}
                      rows={2}
                      placeholder='Enter reason (optional)'
                      style={{ width: 300 }}
                    />
                  </Form.Item>
                </Vertical>
              ),
            }}
          />
          <GraviButton
            size='small'
            onClick={() => {
              setEditing(false)
              form.resetFields()
            }}
            icon={<CloseCircleOutlined />}
          />
        </>
      ) : (
        <>
          <Tooltip title='Edit Pay Items' mouseEnterDelay={0.5} placement='bottom'>
            <GraviButton size='small' onClick={() => setEditing(true)} icon={<EditOutlined />} />
          </Tooltip>
        </>
      )}
    </Horizontal>
  )
}
